import React from "react";
const mata = require("../../assets/mata_laxmi.jpg");

const Header = () => {
  return (
    <header className=" flex justify-between items-center mb-10 border-b-2 p-5 bg-white border-b-red-600">
      <img className="lg:h-[9.375rem] h-[10rem]" src={mata} alt="Satta Matka Casino Results - Kalyan, Madhur, Milan, Star Bazaar" />
      <div className="lg:text-7xl lg:py-5 lg:px-5 lg:rounded-3xl sm:text-5xl sm:py-5 sm:px-5 sm:rounded-3xl px-2 py-2 rounded-xl text-2xl bg-teal-950 text-white">
        SSbossbazar7.com{" "}
      </div>
      <img className=" lg:h-[9.375rem] h-[10rem]" src={mata} alt="Satta Matka Casino Results - Kalyan, Madhur, Milan, Star Bazaar" />
    </header>
  );
};

export default Header;
